import Layout from "@/layouts/default.vue";

export default [
    {
        path: "/oss",
        name: "oss",
        component: Layout,
        redirect: "/oss/file",
        meta: {
            title: "资源中心",
            icon: "config-file",
        },
        children: [
            {
                path: "file",
                name: "oss-file",
                component: () => import("@/views/oss/file-mng.vue"),
                meta: {
                    title: "文件管理",
                    icon: "oss",
                    permission: "manage_oss",
                },
            },
            {
                path: "/document/common",
                name: "document-manage",
                component: () => import("@/views/document/index.vue"),
                meta: {
                    title: "文档管理",
                    icon: "document",
                    app: "common",
                    permission: "manage_common_document",
                },
            },
            {
                path: "/document/edit/:id?",
                name: "document-edit",
                component: () => import("@/views/document/edit.vue"),
                hidden: true,
                meta: {
                    title: "文档内容",
                    icon: "document",
                    activeMenu: "/document/common",
                },
            },
        ],
    },
];
